<template>
  <div>
    <TemplatesList
      v-if="typeState === 'TEMPLATES_LIST'"
      @select-template="selectTemplate"
      @closeTemplatesPicker="closeTemplatesPicker"
    ></TemplatesList>

    <TemplateDetail
      v-if="typeState === 'TEMPLATE_DETAIL' && templateId"
      :teplate-id="templateId"
      @back="backToTemplatesList"
      @closeTemplatesPicker="closeTemplatesPicker"
      @choose-template="$emit('chooseTemplate')"
    ></TemplateDetail>
  </div>
</template>

<script lang="ts" setup>
  import TemplatesList from "./TemplatesList/TemplatesList.vue";
  import TemplateDetail from "./TemplateDetail/TemplateDetail.vue";
  import { ref, Ref } from "vue";

  type TypeState = "TEMPLATES_LIST" | "TEMPLATE_DETAIL";
  const emit = defineEmits(["closeTemplatesPicker", "chooseTemplate"]);

  const typeState = ref<TypeState>("TEMPLATES_LIST");
  const templateId: Ref<number | null> = ref(null);

  function backToTemplatesList() {
    templateId.value = null;
    typeState.value = "TEMPLATES_LIST";
  }

  function selectTemplate(id: number) {
    templateId.value = id;
    typeState.value = "TEMPLATE_DETAIL";
  }

  function closeTemplatesPicker() {
    emit("closeTemplatesPicker");
  }
</script>
